export const icons = {
    //TO DO Add your icons in related group, in case not found group add your group
        application:{
            user:'fa fa-user',
            role:'fa fa-address-card',
            account:'fa fa-universal-access'
        }, 
        list:{
            horizontalList:'fa fa-list'
        },
        emr:{
            harizontalList:'fa fa-list'
        },
}
